const cities = [
  { name: "Wichita", zips: "67202, 67203, 67204, 67205, 67206, 67207, 67208, 67209, 67210, 67211, 67212, 67214, 67215, 67216, 67217, 67218, 67219, 67220, 67223, 67226, 67228, 67230, 67235" },
  { name: "Andover", zips: "67002" },
  { name: "Derby", zips: "67037" },
  { name: "Haysville", zips: "67060" },
  { name: "Goddard", zips: "67052" },
  { name: "Maize", zips: "67101" },
  { name: "Park City", zips: "67219, 67147" },
  { name: "Valley Center", zips: "67147" },
  { name: "Bel Aire", zips: "67220, 67226" },
];

const benefits = [
  {
    icon: "ri-computer-line",
    title: "Start 100% Online",
    desc: "No office visit required to begin. Complete your order from your home, office, or McConnell AFB in minutes.",
  },
  {
    icon: "ri-truck-line",
    title: "Ship Your Documents",
    desc: "Use overnight shipping to send your documents directly to us — we handle every detail from there.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Expert Document Review",
    desc: "Every application is reviewed by our team before submission to reduce errors and prevent delays.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reserved Agency Access",
    desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
  },
];

export default function WichitaLocalAreaSection() {
  return (
    <section id="service-area" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Wichita &amp; South Central Kansas
          </h2>
        </div>

        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-[#F7F8FA] rounded-lg p-8 md:p-10 border border-gray-200">
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              Wichita is the largest city in Kansas and the Air Capital of the World — home to Spirit AeroSystems, Textron Aviation (Cessna and Beechcraft), Bombardier Learjet, and a global aerospace supply chain that sends engineers, executives, and technicians to dozens of countries on short notice. Add to that McConnell Air Force Base, where Air Force families face PCS (permanent change of station) orders with fixed report dates to bases worldwide, and Koch Industries with its international operations spanning 60+ countries, and you have a metro that generates urgent passport demand rivaling much larger cities.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              Wichita State University adds another layer of urgency. WSU sends hundreds of students abroad each year through its study-abroad programs, and the campus is home to a significant international student population whose families need passports for visits and emergencies. The timeline for study-abroad applications is unforgiving — students often have 4–6 weeks between program acceptance and orientation, and many are first-time passport applicants who discover too late they need an in-person acceptance clerk visit.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              The nearest regional passport agencies are in Denver (~525 miles west on I-70) and Dallas (~360 miles south on I-35). That is a 10+ hour round-trip drive — and I-35 construction through Oklahoma and Kansas adds unpredictable delays every summer. For a McConnell family with deployment orders, a Spirit engineer called to a defect investigation in France, or a WSU student with a scholarship-funded semester in Japan, a 10-hour drive to Dallas is not a viable option.
            </p>
            <p className="text-gray-600 text-base leading-[1.8]">
              Fast Passport Center was built for exactly these scenarios. We provide the expedited, professional passport service that Wichita's diverse traveler base demands: dedicated agents who understand military timelines, aerospace urgency, and university deadlines; document review that catches errors before they cost you a semester abroad or a PCS report date; and processing as fast as 24 hours for true emergencies. No driving to Dallas over sun-scorched I-35. No booking a flight to Arkansas. Just reliable, predictable service from a registered U.S. Department of State courier.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-passport-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Wichita, KS</p>
                  <p className="text-white/60 text-xs mt-0.5">Serving Sedgwick County &amp; South Central Kansas</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Remote service — serving Wichita metro, McConnell AFB &amp; South Central Kansas
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Courier pickup available throughout Sedgwick County</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  After signing up online, choose what works best for you: <strong className="text-white">courier pickup</strong> from your home, office, or base, <strong className="text-white">ship with our prepaid label</strong> from any UPS/FedEx location including ICT airport, or <strong className="text-white">schedule a drop-off</strong>. Most clients ship overnight — no visit required.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-[#F7F8FA] rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="bg-[#F7F8FA] rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between py-2.5 px-3 bg-white rounded-md"
                  >
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && (
                      <span className="text-gray-400 text-xs font-mono hidden sm:inline">{city.zips}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in South Central Kansas — start online, ship overnight, and we handle the rest. No need to drive to Dallas or Arkansas for regional agency appointments.
              </p>
              <div className="mt-4 pt-4 border-t border-gray-100">
                <p className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-3">Nearby Cities We Serve</p>
                <div className="flex flex-wrap gap-2">
                  {[
                    { name: "Kansas City, MO", href: "/kansas-city" },
                    { name: "Topeka, KS", href: "/topeka" },
                    { name: "Lawrence, KS", href: "/lawrence" },
                    { name: "Oklahoma City, OK", href: "/oklahoma-city" },
                    { name: "Tulsa, OK", href: "/tulsa" },
                  ].map((link) => (
                    <a
                      key={link.href}
                      href={link.href}
                      className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-white border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                    >
                      {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Wichita Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a
                    key={i}
                    href="https://fastpassportcenter.com"
                    className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}